module.exports = __webpack_public_path__ + "media/meow_2.7c38191c.wav";